var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-list"},[_c('list',{attrs:{"fs":_vm.articleListFields,"apiList":"articles","apiRemove":"articles","editLink":"/admin/articles","title":"Article List"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }